import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';
import AuthHeader from '@/components/auth-header';
import { toaster } from '@/components/ui/toaster';
import api from '@/utils/api';

export default function InviteUser() {
  const { token } = useParams<'token'>();
  const navigate = useNavigate();

  useEffect(() => {
    async function verifyToken() {
      try {
        await api.get(`invite/confirm/${token}`);

        toaster.create({
          type: 'success',
          title: 'Verification successful! Please login to continue.',
        });

        navigate('/auth/login');
      } catch (err: any) {
        toaster.create({
          type: 'error',
          title: err.response?.data?.error || 'Verification failed: Network error',
        });
        navigate('/auth/login');
      }
    }
    verifyToken();
  }, [token, navigate]);

  return (
    <Box py={12} minH={'100vh'}>
      <Box bg={'white'} p={6} mx={'auto'} w={'full'} maxW={'md'} rounded={'md'}>
        <AuthHeader />
        <Box mt={4} textAlign='center'>
          <Spinner borderWidth='4px' animationDuration='0.65s' size='xl' />
        </Box>
      </Box>
    </Box>
  );
}
